import { ComponentType } from 'react';
import { FeatureFlag, UserRole } from '@synergy/models';

import { AccessControl } from './access-control';

export const AccessControlConnect =
    (allowedRoles?: UserRole | UserRole[], allowedFeature?: FeatureFlag, redirect = false) =>
    <P extends object>(WrappedComponent: ComponentType<P>) =>
    (props: P) =>
        (
            <AccessControl allowedRoles={allowedRoles} allowedFeature={allowedFeature} redirect={redirect}>
                <WrappedComponent {...props} />
            </AccessControl>
        );
